import { MenuItemCore, Text } from '@payaca/ambrosia';
import { FC } from 'react';
import {
  SentProposalAction,
  SentProposalActionKey,
} from './sentProposalActions';

type SentProposalActionsListProps = {
  actions: SentProposalAction[];
  /** The action currently running, so its row carries a spinner. */
  processingKey: SentProposalActionKey | null;
};

/**
 * `role="list"` is load-bearing, not decoration — `list-none` strips list
 * semantics in WebKit.
 */
const SentProposalActionsList: FC<SentProposalActionsListProps> = (props) => {
  const { actions, processingKey } = props;

  return (
    <ul
      role="list"
      aria-label="Proposal actions"
      className="m-0 flex list-none flex-col p-3.5"
    >
      {actions.map((action) => (
        <li key={action.key}>
          <MenuItemCore
            iconName={action.iconName}
            disabled={action.disabled}
            disabledReasons={action.disabledReasons}
            isProcessing={processingKey === action.key}
            wrapperClassName="py-2.5"
            onClick={action.onClick}
          >
            {action.key === 'previewAsCustomer' ? (
              // MenuItemCore wraps a string child in its own element, so a row
              // that needs more than a label supplies its own.
              <Text>
                {action.label}
                <span className="sr-only"> (opens in a new tab)</span>
              </Text>
            ) : (
              action.label
            )}
          </MenuItemCore>
        </li>
      ))}
    </ul>
  );
};

export default SentProposalActionsList;
